import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosService from '../../../utility/axiosService/axiosService'
import { API_ENDPOINT } from '../../../utility'
import { toast } from "react-toastify"

export const getMerchantList = createAsyncThunk(
    'merchant/getMerchantList',
    async (data) => {
        // console.log(data)
        if (data == 'all') {
            return await axiosService.get(`${API_ENDPOINT}/admin/merchant`, {
                params: {
                    limit: 10000
                }
            }).then((res) => {
                return res.data;
            });
        } else {
            return await axiosService.get(`${API_ENDPOINT}/admin/merchant`, {
                params: (data ? {
                    page: data.page,
                    search: data.keyword,
                    limit: data.limit
                } : {
                    page: 1,
                    search: ""
                })
            }).then((res) => {
                return res.data;
            });
        }
    }
);

export const createNewMerchant = createAsyncThunk(
    'merchant/createMerchant',
    async (data) => {
        return await axiosService.post(`${API_ENDPOINT}/admin/merchant/`, data).then((res) => {
            return res.data;
        });
    }
);

export const updateMerchant = createAsyncThunk(
    'merchant/updateMerchant',
    async (data) => {

        let updateData = {
            "fullname": data.fullname,
            "username": data.username,
            "logo": data.logo,
            "is_use_API": data.is_use_API,
            "is_active": data.is_active,
            "kpay_id": data.kpay_id,
            "kpay_endpoint":data.kpay_endpoint,
            "kpay_public_key": data.kpay_public_key,
            "kpay_private": data.kpay_private,
            "kpay_public": data.kpay_public,
            "kpay_auth": data.kpay_auth,
        }
        if (data.password) {
            updateData = {
                ...updateData,
                "password": data.password,
            }
        }
        return await axiosService.put(`${API_ENDPOINT}/admin/merchant/${data.id}`, updateData).then((res) => {
            return res;
        });
    }
)

export const genarateTokenMerchant = createAsyncThunk(
    'merchant/genarateTokenMerchant',
    async (data) => {
        // console.log(data);
        const genKeyPos = {
            "merchant_id": data.id
        }
        return await axiosService.post(`${API_ENDPOINT}/api/gen-key`, genKeyPos).then((res) => {
            return res.data;
        });
    }
);

const merchantListSlice = createSlice({
    name: 'merchant',
    initialState: {
        loading: false,
        modal: false,
        data: [],
        total_page: 0,
        dataMerchant: [],
        dataDetails: null,
        error: null,
        // keyword: "",
        // page: 1,
        dataFilter: {
            keyword: "",
            page: 1,
            limit: 10
        },
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        },
        searchTextFieldSlice: (state, { payload }) => {
            state.keyword = payload.data;
        },
        paginationHandleSlice: (state, { payload }) => {
            state.page = payload.data;
        },
        filterData: (state, { payload }) => {
            state.dataFilter.keyword = payload.page ? (payload.keyword || state.dataFilter.keyword) : payload.keyword;
            state.dataFilter.page = payload.page || state.dataFilter.page;
            state.dataFilter.limit = payload.limit || state.dataFilter.limit;
        }
    },
    extraReducers: {
        [getMerchantList.pending]: (state) => {
            state.loading = true;
        },
        [getMerchantList.fulfilled]: (state, { payload }) => {
            state.dataMerchant = payload.data.data;
            state.total_page = payload.data.total_page;
            state.loading = false;
        },
        [createNewMerchant.pending]: (state) => {
            state.loading = true;
        },
        [createNewMerchant.fulfilled]: (state, { payload }) => {
            if (payload.code == 0) {
                // state.dataOrganizations.unshift(payload.data);
                toast.success('Thêm mới thành công !');
                // state.modal = false;
            } else {
                toast.error(`Thêm mới dữ liệu thất bại: ${payload.data.mess}`);
            }
        },
        [createNewMerchant.rejected]: (state, action) => {
            state.error = action;
            state.loading = false;
            toast.error(`Thêm mới dữ liệu thất bại`);
        },
        [updateMerchant.pending]: (state) => {
            state.loading = true;
        },
        [updateMerchant.fulfilled]: (state, { payload }) => {
            state.loading = false;
            if (payload.data.code === 0) {
                toast.success('Cập nhật dữ liệu thành công !');
            } else {
                toast.error(`Cập nhật dữ liệu thất bại: ${payload.data.mess}`);
            }
        },
        [updateMerchant.rejected]: (state, action) => {
            state.error = action;
            state.loading = false;
            toast.error(`Cập nhật dữ liệu thất bại`);
        },
        [genarateTokenMerchant.fulfilled]: (state, { payload }) => {
            console.log(payload);
            if (payload.code == 0) {
                toast.success('Genarate Token thành công !');
            }
        },
        [genarateTokenMerchant.rejected]: (state, action) => {
            state.error = action.payload;
            toast.error(`Generate Token thất bại !`);
        },
    }
});

export const { getModal, removeModal, filterData, searchTextFieldSlice, paginationHandleSlice } = merchantListSlice.actions;

export default merchantListSlice.reducer;